import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-aktualisieren-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerAktualisierenAdminEffects {

    BenutzerAktualisierenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_AKTUALISIEREN_ADMIN),
        mergeMap((x: ac.PostBenutzerAktualisierenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerAktualisierenAdmin(x.benutzerNameRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerAktualisierenAdminErfolgreichAction(result, x.benutzerNameRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerAktualisierenAdminFehlerAction(error, x.benutzerNameRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
